import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [{
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },
  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "",
    component: Layout,
    redirect: "/home",
    hidden: true,
    children: [{
      path: "home",
      name: "home",
      component: () => import("@/views/home/index"),
      meta: {
        title: "首页",
        titleTh: "หน้าแรก",
        titleEn: "Home",
        icon: "home",
        affix: true
      }
    }]
  },
];

export const asyncRouterMap = [{
    path: "/totalBanner",
    component: Layout,
    redirect: "/totalBanner/index",
    name: "totalBanner",
    meta: {
      title: "运营总览",
      titleTh: "",
      titleEn: "",
      icon: "product-list",
    },
    children: [{
      path: "totalBanner",
      name: "totalBanner",
      component: () => import("@/views/totalBanner/index"),
      meta: {
        title: "运营总览",
        titleTh: "",
        titleEn: "",
        icon: "product-list",
      }
    }],
  },
  {
    path: "/bsms",
    component: Layout,
    redirect: "/bsms/openShop",
    name: "bsms",
    meta: {
      title: "品牌运营",
      titleTh: "ดำเนินการแบรนด์",
      titleEn: "Brand operation",
      icon: "product"
    },
    children: [{
        path: "openShop",
        name: "openShop",
        component: () => import("@/views/bsms/openShop/index"),
        meta: {
          title: "开通店铺-品牌管理",
          titleTh: "เปิดร้าน-จัดการแบรนด์",
          titleEn: "Open Shop-brand management",
          icon: "product-list",
        }
      },
      {
        path: "financialSettlementNew",
        name: "financialSettlementNew",
        component: () => import("@/views/bsms/financialSettlementNew/index"),
        meta: {
          title: "运营报表",
          titleTh: "",
          titleEn: "",
          icon: "product-list",
        }
      },
      {
        path: "shipTemplateNew",
        name: "shipTemplateNew",
        component: () => import("@/views/bsms/shipTemplate/index"),
        meta: {
          title: "运费模板",
          titleTh: "รูปแบบค่าส่ง",
          titleEn: "Freight templates",
          icon: "ums-admin"
        },
      },
      {
        path: "shipTemplateAdd",
        name: "shipTemplateAdd",
        component: () => import("@/views/bsms/shipTemplate/addShipTem"),
        meta: {
          title: "新增运费模板",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "shipTemplateUpdate",
        name: "shipTemplateUpdate",
        component: () => import("@/views/bsms/shipTemplate/updateShipTem"),
        meta: {
          title: "编辑运费模板",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "couponProInfo",
        name: "couponProInfo",
        component: () => import("@/views/bsms/couponProMng/couponInfo"),
        meta: {
          title: "优惠券管理",
          titleTh: "จัดการคูปอง",
          titleEn: "Coupon management",
          icon: "ums-admin"
        }
      },
      {
        path: "addCouponPro",
        name: "addCouponPro",
        component: () => import("@/views/bsms/couponProMng/addCoupon"),
        meta: {
          title: "添加优惠券",
          titleTh: "เพิ่มคูปอง",
          titleEn: "Add coupon",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "couponInfoMng",
        name: "couponInfoMng",
        component: () => import("@/views/bsms/couponProMng/couponInfoMng"),
        meta: {
          title: "优惠券详情",
          titleTh: "รายละเอียดคูปอง",
          titleEn: "Coupon details",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "activity",
        name: "activity",
        component: () => import("@/views/sms/activity/index"),
        meta: {
          title: "活动管理",
          titleTh: "จัดการกิจกรรม",
          titleEn: "Activity management",
          icon: "ums"
        },
        hidden: true
      },
      {
        path: "addActivity",
        name: "addActivity",
        component: () => import("@/views/bsms/shopManage/activity/add"),
        meta: {
          title: "添加活动",
          titleTh: "เพิ่มกิจกรรม",
          titleEn: "Add activity",
        },
        hidden: true
      },
      {
        path: "detailActivity",
        name: "detailActivity",
        component: () => import("@/views/bsms/shopManage/activity/detail"),
        meta: {
          title: "活动详情",
          titleTh: "รายละเอียดกิจกรรม",
          titleEn: "Activity details",
        },
        hidden: true
      },
      {
        path: "addTask",
        name: "addTask",
        component: () => import("@/views/bsms/shopManage/task/add"),
        meta: {
          title: "创建口袋任务",
          titleTh: "สร้างกระเป๋าภารกิจ",
          titleEn: "Create pocket task",
        },
        hidden: true
      },
      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/bsms/shopManage/task/addProduct"),
        meta: {
          title: "添加商品",
          titleTh: "เพิ่มสินค้า",
          titleEn: "Add products",
          icon: "product-add"
        },
        hidden: true
      },
      {
        path: "detailTask",
        name: "detailTask",
        component: () => import("@/views/bsms/shopManage/task/detail"),
        meta: {
          title: "口袋任务详情",
          titleTh: "สร้างกระเป๋าภารกิจ",
          titleEn: "Create pocket task",
        },
        hidden: true
      },
      {
        path: "addShop",
        name: "addShop",
        component: () => import("@/views/bsms/openShop/addShop"),
        meta: {
          title: "添加店铺",
          titleTh: "เพิ่มร้านค้า",
          titleEn: "Add shop",
          icon: "product-list",
        },
        hidden: true
      },
      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/bsms/openShop/addBrand"),
        meta: {
          title: "添加品牌",
          titleTh: "เพิ่มแบรนด์",
          titleEn: "Add brand",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "categoryEntry",
        name: "categoryEntry",
        component: () => import("@/views/bsms/openShop/categoryEntry"),
        meta: {
          title: "分类",
          titleTh: "หมวดหมู่",
          titleEn: "Category",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "detailBrand",
        name: "detailBrand",
        component: () => import("@/views/bsms/openShop/detailBrand"),
        meta: {
          title: "品牌详情",
          titleTh: "ข้อมูลแบรนด์",
          titleEn: "Brand details",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "detailShop",
        name: "detailShop",
        component: () => import("@/views/bsms/openShop/detailShop"),
        meta: {
          title: "店铺详情",
          titleTh: "ข้อมูลร้านค้า",
          titleEn: "Shop details",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "createBrandSelfStore",
        name: "createBrandSelfStore",
        component: () => import("@/views/bsms/openBrandStore/createBrandSelfStore"),
        meta: {
          title: "立即创建品牌自营店铺",
          titleTh: "เปิดร้านทันที",
          titleEn: "Create a branded shop now",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "openStoreMngBrandDetail",
        name: "openStoreMngBrandDetail",
        component: () => import("@/views/bsms/openBrandStore/openStoreMngBrand/detail"),
        meta: {
          title: "店铺简介",
          titleTh: "แนะนำร้านค้า",
          titleEn: "Shop profile",
          icon: "sms-ad"
        },
        hidden: true
      },
      {
        path: "openStoreAddInfo",
        name: "openStoreAddInfo",
        component: () => import("@/views/bsms/openBrandStore/openStoreMngBrand/addInfo"),
        meta: {
          title: "补充资料",
          titleTh: "เพิ่มเอกสาร",
          titleEn: "Additional information",
          icon: "sms-ad"
        },
        hidden: true
      },
      {
        path: "storeMng",
        name: "storeMng",
        component: () => import("@/views/bsms/openBrandStore/storeMng/index"),
        meta: {
          title: "开通店铺-品牌管理",
          titleTh: "เปิดร้าน-จัดการแบรนด์",
          titleEn: "Open Shop-brand management",
          icon: "sms-ad"
        }
      },
      {
        path: "storeMngDetail",
        name: "storeMngDetail",
        component: () => import("@/views/bsms/openBrandStore/storeMng/detail"),
        meta: {
          title: "品牌详情",
          titleTh: "ข้อมูลแบรนด์",
          titleEn: "Brand details",
          icon: "sms-ad"
        },
        hidden: true
      },
      {
        path: "SupplyPriceAdjust",
        name: "SupplyPriceAdjust",
        component: () => import("@/views/commodityMng/SupplyPriceAdjust"),
        meta: {
          title: "供货价调价",
          titleTh: "ปรับราคาต้นทุนสินค้า",
          titleEn: "Supply price adjustment",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "SupplyPriceAdjustDetail",
        name: "SupplyPriceAdjustDetail",
        component: () => import("@/views/commodityMng/SupplyPriceAdjustDetail"),
        meta: {
          title: "供货价调价单信息",
          titleTh: "ข้อมูลการปรับราคาต้นทุนสินค้า",
          titleEn: "Supply price adjustment order information",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "addProductNew",
        name: "addProductNew",
        component: () => import("@/views/sms/pocket/addProduct"),
        meta: {
          title: "选择商品",
          titleTh: "เลือกสินค้า",
          titleEn: "Select product",
        },
        hidden: true
      },



      {
        path: "shopManage",
        name: "shopManage",
        component: () => import("@/views/bsms/shopManage/index"),
        meta: {
          title: "店铺管理",
          titleTh: "จัดการร้าน",
          titleEn: "Shop Management",
          icon: "product-add"
        }
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/bsms/shopManage/orderDetail"),
        meta: {
          title: "订单详情",
          titleTh: "ข้อมูลคำสั่งซื้อ",
          titleEn: "Order details",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/bsms/shopManage/applyDetail"),
        meta: {
          title: "退货原因详情",
          titleTh: "รายละเอียดเหตุผลการคืนสินค้า",
          titleEn: "Details of reason for return",
        },
        hidden: true
      },
      {
        path: "immediateDelivery",
        name: "immediateDelivery",
        component: () => import("@/views/bsms/shopManage/immediateDelivery"),
        meta: {
          title: "立即发货",
          titleTh: "จัดส่งทันที",
          titleEn: "Delivery now",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "addPro",
        name: "addPr0",
        component: () => import("@/views/bsms/shopManage/product/add"),
        meta: {
          title: "添加商品",
          titleTh: "เพิ่มสินค้า",
          titleEn: "Add products",
          icon: "product-add"
        },
        hidden: true
      },
      {
        path: "updatePro",
        name: "updatePro",
        component: () => import("@/views/bsms/shopManage/product/update"),
        meta: {
          title: "修改商品",
          titleTh: "แก้ไขสินค้า",
          titleEn: "Edit products",
          icon: "product-add"
        },
        hidden: true
      },
      {
        path: "addBankCard",
        name: "addBankCard",
        component: () => import("@/views/bankCard/addBankCard/index"),
        meta: {
          title: "添加银行卡",
          titleTh: "เพิ่มบัตรธนาคาร",
          titleEn: "Add card",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "mxcomeReview",
        name: "mxcomeReview",
        component: () => import("@/views/bsms/openBrandStore/component/mxcomeReview"),
        meta: {
          title: "《MXCOME商家服务协议》",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/commodityMng",
    component: Layout,
    redirect: "/commodityMng/commodityMngChild",
    name: "commodityMng",
    meta: {
      title: "商品管理",
      icon: "product"
    },
    children: [{
        path: "commodityMngChild",
        name: "commodityMngChild",
        component: () => import("@/views/commodityMng/commodityMngChild"),
        meta: {
          title: "商品管理",
          titleTh: "จัดการสินค้า",
          titleEn: "Product management",
          icon: "product-list"
        }
      },
      {
        path: "commodityMngAuth",
        name: "commodityMngAuth",
        component: () => import("@/views/commodityMng/commodityMngAuth"),
        meta: {
          title: "商品管理及审核",
          titleTh: "จัดการและตรวจสอบสินค้า",
          titleEn: "Product management and audit",
          icon: "product-list"
        }
      },
      {
        path: "listSpecifyDistirbute",
        name: "listSpecifyDistirbute",
        component: () => import("@/views/specifyDistributionGoods/listSpecifyDistirbute"),
        meta: {
          title: "分润比例调整",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
      },
      {
        path: "detailSpecifyDistirbute",
        name: "detailSpecifyDistirbute",
        component: () => import("@/views/specifyDistributionGoods/detailSpecifyDistirbute"),
        meta: {
          title: "分润比例调整详情",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "SupplyPriceAdjustDetail",
        name: "SupplyPriceAdjustDetail",
        component: () => import("@/views/commodityMng/SupplyPriceAdjustDetail"),
        meta: {
          title: "供货价调价单信息",
          titleTh: "ข้อมูลการปรับราคาต้นทุนสินค้า",
          titleEn: "Supply price adjustment order information",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "SupplyPriceAdjust",
        name: "SupplyPriceAdjust",
        component: () => import("@/views/commodityMng/SupplyPriceAdjust"),
        meta: {
          title: "供货价调价",
          titleTh: "ปรับราคาต้นทุนสินค้า",
          titleEn: "Supply price adjustment",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "priceAdjustList",
        name: "priceAdjustList",
        component: () => import("@/views/commodityMng/priceAdjustList"),
        meta: {
          title: "淘金价调价及审核",
          titleTh: "ปรับราคาและตรวจสอบราคา MXCOME",
          titleEn: "MXCOME price adjustment and audit",
          icon: "product-list"
        }
      },
      {
        path: "supplyPriceAuth",
        name: "supplyPriceAuth",
        component: () => import("@/views/commodityMng/supplyPriceAuth"),
        meta: {
          title: "供货价审核",
          titleTh: "ตรวจสอบราคาต้นทุนสินค้า",
          titleEn: "Supply price audit",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "priceAuth",
        name: "priceAuth",
        component: () => import("@/views/commodityMng/priceAuth"),
        meta: {
          title: "淘金价审核",
          titleTh: "ตรวจสอบราคา MXCOME",
          titleEn: "MXCOME price audit",
          icon: "product-list"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/openBrandStore",
    component: Layout,
    redirect: "/openBrandStore/openStoreMngBrand",
    name: "openBrandStore",
    meta: {
      title: "开通品牌、店铺",
      icon: "product"
    },
    children: [{
        path: "openStoreMngBrand",
        name: "openStoreMngBrand",
        component: () => import("@/views/openBrandStore/openStoreMngBrand/index"),
        meta: {
          title: "店铺管理",
          titleTh: "จัดการร้านค้า",
          titleEn: "Shop management",
          icon: "sms-ad"
        }
      },
      {
        path: "openStoreMngBrandDetail",
        name: "openStoreMngBrandDetail",
        component: () => import("@/views/openBrandStore/openStoreMngBrand/detail"),
        meta: {
          title: "店铺简介",
          titleTh: "แนะนำร้านค้า",
          titleEn: "Shop profile",
          icon: "sms-ad"
        },
        hidden: true
      },
      {
        path: "openStoreAddInfo",
        name: "openStoreAddInfo",
        component: () => import("@/views/openBrandStore/openStoreMngBrand/addInfo"),
        meta: {
          title: "补充资料",
          titleTh: "เพิ่มเอกสาร",
          titleEn: "Additional information",
          icon: "sms-ad"
        },
        hidden: true
      },
      {
        path: "storeMng",
        name: "storeMng",
        component: () => import("@/views/openBrandStore/storeMng/index"),
        meta: {
          title: "开通店铺-品牌管理",
          titleTh: "เปิดร้าน-จัดการแบรนด์",
          titleEn: "Open Shop-brand management",
          icon: "sms-ad"
        }
      },
      {
        path: "storeMngDetail",
        name: "storeMngDetail",
        component: () => import("@/views/openBrandStore/storeMng/detail"),
        meta: {
          title: "品牌详情",
          titleTh: "ข้อมูลแบรนด์",
          titleEn: "Brand details",
          icon: "sms-ad"
        },
        hidden: true
      },
      {
        path: "createBrandSelfStore",
        name: "createBrandSelfStore",
        component: () => import("@/views/openBrandStore/createBrandSelfStore"),
        meta: {
          title: "开启品牌自营",
          titleTh: "เปิดร้านค้า",
          titleEn: "Open brand self-operation",
          icon: "sms-ad"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/mng",
    component: Layout,
    redirect: "/mng/userAuthenticate",
    name: "mng",
    meta: {
      title: "管理",
      titleTh: "จัดการ",
      titleEn: "Management",
      icon: "product"
    },
    children: [{
        path: "authList",
        name: "authList",
        component: () => import("@/views/mng/authList/index"),
        meta: {
          title: "审核页面",
          titleTh: "หน้ารวมการตรวจสอบ",
          titleEn: "Audit page",
          icon: "sms-ad"
        }
      },
      {
        path: "userAuthenticate",
        name: "userAuthenticate",
        component: () => import("@/views/mng/userAuthenticate/index"),
        meta: {
          title: "用户实名",
          titleTh: "ยืนยันตัวตนผู้ใช้",
          titleEn: "User verification",
          icon: "product-list"
        }
      },
      {
        path: "brandAudit",
        name: "brandAudit",
        component: () => import("@/views/mng/brandAudit/index"),
        meta: {
          title: "品牌审核",
          titleTh: "ตรวจสอบแบรนด์",
          titleEn: "Brand audit",
          icon: "product-list"
        }
      },
      {
        path: "brandShopAuth",
        name: "brandShopAuth",
        component: () => import("@/views/mng/brandShopAuth/index"),
        meta: {
          title: "品牌店铺审核",
          titleTh: "ตรวจสอบแบรนด์",
          titleEn: "Shop audit",
          icon: "product-list"
        }
      },
      {
        path: "brandShopDetail",
        name: "brandShopDetail",
        component: () => import("@/views/mng/brandShopAuth/detail"),
        meta: {
          title: "开通品牌店铺详情",
          titleTh: "รายละเอียดการเปิดร้านค้า",
          titleEn: "Details of a branded shop",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "activeAudit",
        name: "activeAudit",
        component: () => import("@/views/mng/activeAudit/index"),
        meta: {
          title: "活动审核",
          titleTh: "ตรวจสอบกิจกรรม",
          titleEn: "Activity audit",
          icon: "product-list"
        }
      },
      {
        path: "productAudit",
        name: "productAudit",
        component: () => import("@/views/mng/productAudit/index"),
        meta: {
          title: "商品审核",
          titleTh: "ตรวจสอบสินค้า",
          titleEn: "Product audit",
          icon: "product-list"
        }
      },
      {
        path: "authPro",
        name: "authPro",
        component: () => import("@/views/mng/productAudit/authPro"),
        meta: {
          title: "审核商品",
          titleTh: "ตรวจสอบสินค้า",
          titleEn: "Audit products",
          icon: "product-add"
        },
        hidden: true
      },
      {
        path: "shopWithdraw",
        name: "shopWithdraw",
        component: () => import("@/views/mng/withdrawAudit/shopWithdraw/index"),
        meta: {
          title: "商家提现",
          titleTh: "การถอนเงินของร้านค้า",
          titleEn: "Merchant withdrawals",
          icon: "product-list"
        }
      },
      {
        path: "widthdrawDetail",
        name: "widthdrawDetail",
        component: () => import("@/views/mng/withdrawAudit/widthdrawDetail/index"),
        meta: {
          title: "提现详情",
          titleTh: "ข้อมูลการถอนเงิน",
          titleEn: "Withdrawal details",
          icon: "product-list"
        },
        hidden: true
      },
      {
        path: "userWithdraw",
        name: "userWithdraw",
        component: () => import("@/views/mng/withdrawAudit/userWithdraw/index"),
        meta: {
          title: "用户/达人提现",
          titleTh: "การถอนเงินของผู้ใช้/MXWINNER",
          titleEn: "Users / MXWINNER Withdrawals",
          icon: "product-list"
        }
      },
      {
        path: "activeAuditDetail",
        name: "activeAuditDetail",
        component: () => import("@/views/mng/activeAudit/detail"),
        meta: {
          title: "活动审核详情",
          titleTh: "ข้อมูลการตรวจสอบกิจกรรม",
          titleEn: "Activity audit details",
          icon: "product-list"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/websiteOperation",
    component: Layout,
    redirect: "/websiteOperation/super3/",
    name: "websiteOperation",
    meta: {
      title: "官网运营后台管理",
      titleTh: "",
      titleEn: "",
      icon: "product"
    },
    children: [{
        path: "super3",
        name: "super3",
        component: () => import("@/views/websiteOperation/super3/index"),
        meta: {
          title: "超级星期三任务管理",
          titleTh: "",
          titleEn: "",
          icon: "sms-ad"
        }
      },
      {
        path: "suggestionFeedback",
        name: "suggestionFeedback",
        component: () => import("@/views/websiteOperation/suggestionFeedback/index"),
        meta: {
          title: "建议反馈",
          titleTh: "",
          titleEn: "",
          icon: "sms-ad"
        }
      },
      {
        path: "signboardMng",
        name: "signboardMng",
        component: () => import("@/views/websiteOperation/signboardMng/index"),
        meta: {
          title: "招聘管理",
          titleTh: "",
          titleEn: "",
          icon: "sms-ad"
        }
      },
      {
        path: "resumeMng",
        name: "resumeMng",
        component: () => import("@/views/websiteOperation/resumeMng/index"),
        meta: {
          title: "简历管理",
          titleTh: "",
          titleEn: "",
          icon: "sms-ad"
        }
      },
      {
        path: "addSignboardMng",
        name: "addSignboardMng",
        component: () => import("@/views/websiteOperation/signboardMng/add"),
        meta: {
          title: "添加/编辑招聘管理",
          titleTh: "",
          titleEn: "",
          icon: "sms-ad"
        },
        hidden: true
      },
      {
        path: "MakeAppointVisit",
        name: "MakeAppointVisit",
        component: () => import("@/views/websiteOperation/MakeAppointVisit/index"),
        meta: {
          title: "预约来访管理",
          titleTh: "",
          titleEn: "",
          icon: "sms-ad"
        }
      },
      {
        path: "newRedJoin",
        name: "newRedJoin",
        component: () => import("@/views/websiteOperation/newRedJoin/index"),
        meta: {
          title: "网红加入管理",
          titleTh: "",
          titleEn: "",
          icon: "sms-ad"
        }
      },
      {
        path: "copyrightAuthorizaMng",
        name: "copyrightAuthorizaMng",
        component: () => import("@/views/websiteOperation/copyrightAuthorizaMng/index"),
        meta: {
          title: "版权授权申请管理",
          titleTh: "",
          titleEn: "",
          icon: "sms-ad"
        }
      }
    ]
  },
  {
    path: "/pms",
    component: Layout,
    redirect: "/pms/product",
    name: "pms",
    meta: {
      title: "商品",
      titleTh: "สินค้า",
      titleEn: "Product",
      icon: "product"
    },
    children: [{
        path: "product",
        name: "product",
        component: () => import("@/views/pms/product/index"),
        meta: {
          title: "商品列表",
          titleTh: "รายการสินค้า",
          titleEn: "Product list",
          icon: "product-list"
        }
      },
      {
        path: "addProduct",
        name: "addProduct",
        component: () => import("@/views/pms/product/add"),
        meta: {
          title: "添加商品",
          titleTh: "เพิ่มสินค้า",
          titleEn: "Add products",
          icon: "product-add"
        },
        hidden: true
      },
      {
        path: "updateProduct",
        name: "updateProduct",
        component: () => import("@/views/pms/product/update"),
        meta: {
          title: "修改商品",
          titleTh: "แก้ไขสินค้า",
          titleEn: "Modify products",
          icon: "product-add"
        },
        hidden: true
      },
      {
        path: "detail",
        name: "detail",
        component: () => import("@/views/pms/product/detail"),
        meta: {
          title: "查看详情",
          titleTh: "ดูข้อมูล",
          titleEn: "View details",
          icon: "product-add"
        },
        hidden: true
      },
      {
        path: "productCate",
        name: "productCate",
        component: () => import("@/views/pms/productCate/index"),
        meta: {
          title: "商品分类",
          titleTh: "หมวดหมู่สินค้า",
          titleEn: "Category",
          icon: "product-cate"
        }
      },
      {
        path: "addProductCate",
        name: "addProductCate",
        component: () => import("@/views/pms/productCate/add"),
        meta: {
          title: "添加商品分类",
          titleTh: "เพิ่มหมวดหมู่สินค้า",
          titleEn: "Add category",
        },
        hidden: true
      },
      {
        path: "updateProductCate",
        name: "updateProductCate",
        component: () => import("@/views/pms/productCate/update"),
        meta: {
          title: "修改商品分类",
          titleTh: "แก้ไขหมวดหมู่สินค้า",
          titleEn: "Modify category",
        },
        hidden: true
      },
      {
        path: "productAttr",
        name: "productAttr",
        component: () => import("@/views/pms/productAttr/index"),
        meta: {
          title: "商品类型",
          titleTh: "ประเภทสินค้า",
          titleEn: "Product Type",
          icon: "product-attr"
        }
      },
      {
        path: "productAttrList",
        name: "productAttrList",
        component: () => import("@/views/pms/productAttr/productAttrList"),
        meta: {
          title: "商品属性列表",
          titleTh: "รายการคุณลักษณะสินค้า",
          titleEn: "Product attribute list",
        },
        hidden: true
      },
      {
        path: "addProductAttr",
        name: "addProductAttr",
        component: () => import("@/views/pms/productAttr/addProductAttr"),
        meta: {
          title: "添加商品属性"
        },
        hidden: true
      },
      {
        path: "updateProductAttr",
        name: "updateProductAttr",
        component: () => import("@/views/pms/productAttr/updateProductAttr"),
        meta: {
          title: "修改商品属性"
        },
        hidden: true
      },
      {
        path: "brand",
        name: "brand",
        component: () => import("@/views/pms/brand/index"),
        meta: {
          title: "品牌管理",
          titleTh: "จัดการแบรนด์",
          titleEn: "Brand management",
          icon: "product-brand"
        }
      },
      {
        path: "addBrand",
        name: "addBrand",
        component: () => import("@/views/pms/brand/add"),
        meta: {
          title: "添加品牌",
          titleTh: "เพิ่มแบรนด์",
          titleEn: "Add brands",
        },
        hidden: true
      },
      {
        path: "updateBrand",
        name: "updateBrand",
        component: () => import("@/views/pms/brand/update"),
        meta: {
          title: "编辑品牌",
          titleTh: "แก้ไขแบรนด์",
          titleEn: "Edit brands",
        },
        hidden: true
      },
    ]
  },
  {
    path: "/oms",
    component: Layout,
    redirect: "/oms/order",
    name: "oms",
    meta: {
      title: "订单",
      titleTh: "คำสั่งซื้อ",
      titleEn: "Order",
      icon: "order"
    },
    children: [{
        path: "order",
        name: "order",
        component: () => import("@/views/oms/order/index"),
        meta: {
          title: "订单列表",
          titleTh: "รายการคำสั่งซื้อ",
          titleEn: "Order list",
          icon: "product-list"
        }
      },
      {
        path: "orderDetail",
        name: "orderDetail",
        component: () => import("@/views/oms/order/orderDetail"),
        meta: {
          title: "订单详情",
          titleTh: "รายละเอียดคำสั่งซื้อ",
          titleEn: "Order details",
        },
        hidden: true
      },
      {
        path: "deliverOrderList",
        name: "deliverOrderList",
        component: () => import("@/views/oms/order/deliverOrderList"),
        meta: {
          title: "发货列表",
          titleTh: "รายการจัดส่ง",
          titleEn: "Delivery list",
        },
        hidden: true
      },
      {
        path: "orderSetting",
        name: "orderSetting",
        component: () => import("@/views/oms/order/setting"),
        meta: {
          title: "订单设置",
          titleTh: "ตั้งค่าคำสั่งซื้อ",
          titleEn: "Order settings",
          icon: "order-setting"
        }
      },
      {
        path: "returnApply",
        name: "returnApply",
        component: () => import("@/views/oms/apply/index"),
        meta: {
          title: "退货申请处理",
          titleTh: "จัดการคำขอคืนสินค้า",
          titleEn: "Return request processing",
          icon: "order-return"
        }
      },
      {
        path: "returnReason",
        name: "returnReason",
        component: () => import("@/views/oms/apply/reason"),
        meta: {
          title: "退货原因设置",
          titleTh: "ตั้งค่าเหตุผลการคืนสินค้า",
          titleEn: "Return reason setting",
          icon: "order-return-reason"
        }
      },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/bsms/shopManage/applyDetail"),
        // component: () => import("@/views/oms/apply/applyDetail"),
        meta: {
          title: "退货原因详情",
          titleTh: "รายละเอียดเหตุผลการคืนสินค้า",
          titleEn: "Return reason details",
        },
        hidden: true
      }
    ]
  },
  {
    path: "/operatStatement",
    component: Layout,
    redirect: "/operatStatement/userDevelopDataReport",
    name: "operatStatement",
    meta: {
      title: "运营报表",
      titleTh: "รายงานการดำเนินการ",
      titleEn: "Operating statements",
      icon: "sms"
    },
    children: [{
        path: "userDevelopDataReport",
        name: "userDevelopDataReport",
        component: () => import("@/views/operatStatement/userDevelopDataReport/index"),
        meta: {
          title: "用户发展数据报表",
          titleTh: "รายงานการเติบโตของผู้ใช้",
          titleEn: "User development data sheet",
          icon: "sms-flash"
        }
      },
      {
        path: "redPackageDataReport",
        name: "redPackageDataReport",
        component: () => import("@/views/operatStatement/redPackageDataReport/index"),
        meta: {
          title: "红包闯关数据报表",
          titleTh: "",
          titleEn: "",
          icon: "sms-flash"
        }
      },
    ]
  },
  {
    path: "/sms",
    component: Layout,
    redirect: "/sms/coupon",
    name: "sms",
    meta: {
      title: "运营",
      titleTh: "การตลาด",
      titleEn: "Marketing",
      icon: "sms"
    },
    children: [{
        path: "flash",
        name: "flash",
        component: () => import("@/views/sms/flash/index"),
        meta: {
          title: "秒杀活动列表",
          titleTh: "รายการกิจกรรม Flash Sale",
          titleEn: "Flash Sale activity list",
          icon: "sms-flash"
        }
      },
      {
        path: "flashSession",
        name: "flashSession",
        component: () => import("@/views/sms/flash/sessionList"),
        meta: {
          title: "秒杀时间段列表"
        },
        hidden: true
      },
      {
        path: "selectSession",
        name: "selectSession",
        component: () => import("@/views/sms/flash/selectSessionList"),
        meta: {
          title: "秒杀时间段选择"
        },
        hidden: true
      },
      {
        path: "flashProductRelation",
        name: "flashProductRelation",
        component: () => import("@/views/sms/flash/productRelationList"),
        meta: {
          title: "秒杀商品列表"
        },
        hidden: true
      },
      {
        path: "coupon",
        name: "coupon",
        component: () => import("@/views/sms/coupon/index"),
        meta: {
          title: "优惠券列表",
          titleTh: "รายการคูปอง",
          titleEn: "Coupon list",
          icon: "sms-coupon"
        }
      },
      {
        path: "leaderDevReport",
        name: "leaderDevReport",
        component: () => import("@/views/sms/leaderDevReport/index"),
        meta: {
          title: "团长发展体系报表",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        }
      },
      {
        path: "headDevPurRecords",
        name: "headDevPurRecords",
        component: () => import("@/views/sms/headDevPurRecords/index"),
        meta: {
          title: "团长发展购买记录",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        }
      },
      {
        path: "returnApplyDetail",
        name: "returnApplyDetail",
        component: () => import("@/views/bsms/shopManage/applyDetail"),
        meta: {
          title: "退货原因详情",
          titleTh: "รายละเอียดเหตุผลการคืนสินค้า",
          titleEn: "Details of reason for return",
        },
        hidden: true
      },



      {
        path: "updateCoupon",
        name: "updateCoupon",
        component: () => import("@/views/sms/coupon/update"),
        meta: {
          title: "修改优惠券",
          titleTh: "แก้ไขคูปอง",
          titleEn: "Modify coupons",
        },
        hidden: true
      },
      {
        path: "couponHistory",
        name: "couponHistory",
        component: () => import("@/views/sms/coupon/history"),
        meta: {
          title: "优惠券领取详情",
          titleTh: "ข้อมูลการรับคูปอง",
          titleEn: "Coupon claim details",
        },
        hidden: true
      },
      {
        path: "brand",
        name: "homeBrand",
        component: () => import("@/views/sms/brand/index"),
        meta: {
          title: "品牌推荐",
          titleTh: "แบรนด์แนะนำ",
          titleEn: "Brand recommendation",
          icon: "product-brand"
        }
      },
      {
        path: "new",
        name: "homeNew",
        component: () => import("@/views/sms/new/index"),
        meta: {
          title: "新品推荐",
          icon: "sms-new"
        }
      },
      {
        path: "hot",
        name: "homeHot",
        component: () => import("@/views/sms/hot/index"),
        meta: {
          title: "人气推荐",
          icon: "sms-hot"
        }
      },
      {
        path: "subject",
        name: "homeSubject",
        component: () => import("@/views/sms/subject/index"),
        meta: {
          title: "专题推荐",
          icon: "sms-subject"
        }
      },
      {
        path: "redPackage",
        name: "redPackage",
        component: () => import("@/views/sms/redPackage/index"),
        meta: {
          title: "红包闯关任务管理",
          titleTh: "จัดการภารกิจอั่งเปา",
          titleEn: "Red Packet Missions Management",
          icon: "sms-ad"
        }
      },
      {
        path: "redPackageAdd",
        name: "redPackageAdd",
        component: () => import("@/views/sms/redPackage/add"),
        meta: {
          title: "添加红包闯关任务",
          titleTh: "เพิ่มภารกิจอั่งเปา",
          titleEn: "Add Red Packet Mission",
        },
        hidden: true
      },
      {
        path: "redPackageDetail",
        name: "redPackageDetail",
        component: () => import("@/views/sms/redPackage/detail"),
        meta: {
          title: "红包闯关任务详情",
          titleTh: "รายละเอียดภารกิจอั่งเปา",
          titleEn: "Red Packet Details",
        },
        hidden: true
      },


      {
        path: "advertise",
        name: "homeAdvertise",
        component: () => import("@/views/sms/advertise/index"),
        meta: {
          title: "广告列表",
          titleTh: "รายการโฆษณา",
          titleEn: "Advertisement list",
          icon: "sms-ad"
        }
      },
      {
        path: "addAdvertise",
        name: "addHomeAdvertise",
        component: () => import("@/views/sms/advertise/add"),
        meta: {
          title: "添加广告",
          titleTh: "เพิ่มโฆษณา",
          titleEn: "Add advertisement",
        },
        hidden: true
      },
      {
        path: "updateAdvertise",
        name: "updateHomeAdvertise",
        component: () => import("@/views/sms/advertise/update"),
        meta: {
          title: "编辑广告",
          titleTh: "แก้ไขโฆษณา",
          titleEn: "Edit advertisement",
        },
        hidden: true
      },
      {
        path: "pocket",
        name: "pocket",
        component: () => import("@/views/sms/pocket/index"),
        meta: {
          title: "口袋任务列表",
          titleTh: "รายการกระเป๋าภารกิจ",
          titleEn: "Pocket task list",
          icon: "product-list",
          keepAlive: false
        }
      },
      {
        path: "addPocket",
        name: "addPocket",
        component: () => import("@/views/sms/pocket/add"),
        meta: {
          title: "创建口袋任务",
          titleTh: "สร้างกระเป๋าภารกิจ",
          titleEn: "Create pocket task",
        },
        hidden: true
      },
      {
        path: "addProductNew",
        name: "addProductNew",
        component: () => import("@/views/sms/pocket/addProduct"),
        meta: {
          title: "选择商品",
          titleTh: "เลือกสินค้า",
          titleEn: "Select product",
        },
        hidden: true
      },
      {
        path: "detailPocket",
        name: "detailPocket",
        component: () => import("@/views/sms/pocket/detail"),
        meta: {
          title: "查看口袋任务详情",
          titleTh: "ดูข้อมูลกระเป๋าภารกิจ",
          titleEn: "View pocket task details",
        },
        hidden: true
      },
      {
        path: "activity",
        name: "activity",
        component: () => import("@/views/sms/activity/index"),
        meta: {
          title: "活动管理",
          titleTh: "จัดการกิจกรรม",
          titleEn: "Activity management",
          icon: "ums"
        }
      },
      {
        path: "addActivity",
        name: "addActivity",
        component: () => import("@/views/sms/activity/add"),
        meta: {
          title: "添加活动",
          titleTh: "เพิ่มกิจกรรม",
          titleEn: "Add activity",
        },
        hidden: true
      },
      {
        path: "detailActivity",
        name: "detailActivity",
        component: () => import("@/views/sms/activity/detail"),
        meta: {
          title: "活动详情",
          titleTh: "รายละเอียดกิจกรรม",
          titleEn: "Activity details",
        },
        hidden: true
      },
      {
        path: "sign",
        name: "sign",
        component: () => import("@/views/sms/sign/index"),
        meta: {
          title: "签到管理",
          titleTh: "จัดการการลงชื่อ",
          titleEn: "Check-in management",
          icon: "ums"
        }
      },
      {
        path: "news",
        name: "news",
        component: () => import("@/views/sms/news/index"),
        meta: {
          title: "新闻管理",
          icon: "ums"
        }
      },
      {
        path: "addNews",
        name: "addNews",
        component: () => import("@/views/sms/news/add"),
        meta: {
          title: "添加新闻"
        },
        hidden: true
      },
      {
        path: "updateNews",
        name: "updateNews",
        component: () => import("@/views/sms/news/update"),
        meta: {
          title: "修改新闻"
        },
        hidden: true
      },
      {
        path: "productLevel",
        name: "productLevel",
        component: () => import("@/views/sms/productLevel/index"),
        meta: {
          title: "商品分级",
          titleTh: "แบ่งระดับสินค้า",
          titleEn: "Product rating",
          icon: "sms-flash"
        },
      },
    ]
  },
  {
    path: "/assetCenter",
    component: Layout,
    redirect: "/assetCenter/assetCenter",
    name: "assetCenter",
    meta: {
      title: "资产中心",
      titleTh: "ศูนย์รวมสินทรัพย์",
      titleEn: "Asset Centre",
      icon: "ums"
    },
    children: [{
        path: "assetCenter",
        name: "assetCenter",
        component: () => import("@/views/assetCenter/assetCenter/index"),
        meta: {
          title: "资产中心",
          titleTh: "ศูนย์รวมสินทรัพย์",
          titleEn: "Asset Centre",
          icon: "ums-admin"
        }
      },
      {
        path: "bankCard",
        name: "bankCard",
        component: () => import("@/views/bankCard/bankCard/index"),
        meta: {
          title: "银行卡管理",
          titleTh: "จัดการบัตรธนาคาร",
          titleEn: "Card management",
          icon: "ums-admin"
        }
      },
      {
        path: "withdrawalApply",
        name: "withdrawalApply",
        component: () => import("@/views/assetCenter/withdrawalApply/index"),
        meta: {
          title: "提现申请",
          titleTh: "คำขอถอนเงิน",
          titleEn: "Withdrawal application",
          icon: "ums-admin"
        }
      },
      {
        path: "widthdrawDetail",
        name: "widthdrawDetail",
        component: () => import("@/views/assetCenter/widthdrawDetail/index"),
        meta: {
          title: "提现详情",
          icon: "product-list"
        },
        hidden: true
      },
    ]
  },
  // {
  //   path: "/bankCard",
  //   component: Layout,
  //   redirect: "/bankCard/bankCard",
  //   name: "bankCard",
  //   meta: {
  //     title: "银行卡管理",
  //     titleTh: "จัดการบัตรธนาคาร",
  //     titleEn: "Card management",
  //     icon: "ums"
  //   },
  //   children: [
  //     {
  //       path: "bankCard",
  //       name: "bankCard",
  //       component: () => import("@/views/bankCard/bankCard/index"),
  //       meta: {
  //         title: "银行卡管理",
  //         titleTh: "จัดการบัตรธนาคาร",
  //         titleEn: "Card management",
  //         icon: "ums-admin"
  //       },
  //     },
  //     {
  //       path: "addBankCard",
  //       name: "addBankCard",
  //       component: () => import("@/views/bankCard/addBankCard/index"),
  //       meta: {
  //         title: "添加银行卡",
  //         titleTh: "เพิ่มบัตรธนาคาร",
  //         titleEn: "Add card",
  //         icon: "ums-admin"
  //       },
  //       hidden: true
  //     },
  //   ]
  // },
  {
    path: "/bankCardMng",
    component: Layout,
    redirect: "/bankCardMng/bankCardMng",
    name: "bankCardMng",
    meta: {
      title: "银行管理",
      titleTh: "จัดการธนาคาร",
      titleEn: "Bank management",
      icon: "ums"
    },
    children: [{
      path: "bankCardMng",
      name: "bankCardMng",
      component: () => import("@/views/bankCardMng/bankCardMng"),
      meta: {
        title: "银行管理",
        titleTh: "จัดการธนาคาร",
        titleEn: "Bank managemen",
        icon: "ums-admin"
      },

    }, ]
  },
  {
    path: "/RedEnvelopeMng",
    component: Layout,
    redirect: "/RedEnvelopeMng/RedEnvelope",
    name: "RedEnvelopeMng",
    meta: {
      title: "红包资格管理",
      titleTh: "จัดการคุณสมบัติฝ่าด่านพิชิตอั่งเปา",
      titleEn: "en",
      icon: "ums"
    },
    children: [{
        path: "RedEnvelope",
        name: "RedEnvelope",
        component: () => import("@/views/RedEnvelopeMng/RedEnvelope"),
        meta: {
          title: "红包资格管理",
          titleTh: "จัดการคุณสมบัติฝ่าด่านพิชิตอั่งเปา",
          titleEn: "Red packet eligibility management",
          icon: "ums-admin"
        }
      },
      {
        path: "addRedPacket",
        name: "addRedPacket",
        component: () => import("@/views/RedEnvelopeMng/addRedPacket"),
        meta: {
          title: "添加红包闯关资格",
          titleTh: "เพิ่มคุณสมบัติฝ่าด่านพิชิตอั่งเปา",
          titleEn: "Add qualification for red packet activity",
          icon: "ums-admin"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/financialSettlement",
    component: Layout,
    redirect: "/financialSettlement/stockInquiryReport",
    name: "financialSettlement",
    meta: {
      title: "财务报表",
      titleTh: "รายงานบัญชี",
      titleEn: "Financial statement",
      icon: "ums"
    },
    children: [{
        path: "proReconciliation",
        name: "proReconciliation",
        component: () => import("@/views/financialSettlement/proReconciliation/index"),
        meta: {
          title: "商品对账表",
          titleTh: "รายงานรายการสินค้า",
          titleEn: "Product account checking",
          icon: "ums-admin"
        }
      },
      // {
      //   path: "leaderDevReport",
      //   name: "leaderDevReport",
      //   component: () => import("@/views/financialSettlement/leaderDevReport/index"),
      //   meta: {
      //     title: "团长发展体系报表",
      //     titleTh: "",
      //     titleEn: "",
      //     icon: "ums-admin"
      //   }
      // },
      // {
      //   path: "headDevPurRecords",
      //   name: "headDevPurRecords",
      //   component: () => import("@/views/financialSettlement/headDevPurRecords/index"),
      //   meta: {
      //     title: "团长发展购买记录",
      //     titleTh: "",
      //     titleEn: "",
      //     icon: "ums-admin"
      //   }
      // },
      {
        path: "stockInquiryReport",
        name: "stockInquiryReport",
        component: () => import("@/views/financialSettlement/stockInquiryReport/index"),
        meta: {
          title: "库存查询报表",
          titleTh: "รายงานการตรวจสอบคลัง",
          titleEn: "Inventory enquiry report",
          icon: "ums-admin"
        }
      },
      {
        path: "salesReport",
        name: "salesReport",
        component: () => import("@/views/financialSettlement/salesReport/index"),
        meta: {
          title: "销售报表",
          titleTh: "รายงานยอดขาย",
          titleEn: "Sales report",
          icon: "ums-admin"
        }
      },
      {
        path: "stockWarning",
        name: "stockWarning",
        component: () => import("@/views/financialSettlement/stockWarning/index"),
        meta: {
          title: "库存预警",
          titleTh: "แจ้งเตือนสต็อกสินค้า",
          titleEn: "Stock alert",
          icon: "ums-admin"
        }
      },
    ]
  },
  {
    path: "/logistics",
    component: Layout,
    redirect: "/logistics/logisCompany",
    name: "logistics",
    meta: {
      title: "物配送流",
      titleTh: "บริษัทขนส่ง",
      titleEn: "Logistics",
      icon: "ums"
    },
    children: [{
        path: "logisCompany",
        name: "logisCompany",
        component: () => import("@/views/logistics/logisCompany/index"),
        meta: {
          title: "物流公司",
          titleTh: "บริษัทขนส่ง",
          titleEn: "Logistics company",
          icon: "ums-admin"
        }
      },
      {
        path: "shipTemplate",
        name: "shipTemplate",
        component: () => import("@/views/logistics/shipTemplate/index"),
        meta: {
          title: "运费模板",
          titleTh: "รูปแบบค่าส่ง",
          titleEn: "Freight templates",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "addShipTem",
        name: "addShipTem",
        component: () => import("@/views/logistics/shipTemplate/addShipTem"),
        meta: {
          title: "新建运费模板",
          titleTh: "สร้างรูปแบบค่าส่งใหม่",
          titleEn: "Create new freight template",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "updateShipTem",
        name: "updateShipTem",
        component: () => import("@/views/logistics/shipTemplate/updateShipTem"),
        meta: {
          title: "编辑运费模板",
          titleTh: "แก้ไขรูปแบบค่าส่ง",
          titleEn: "Edit freight template",
          icon: "ums-admin"
        },
        hidden: true
      }
    ]
  },
  {
    path: "/goldPanCollege",
    component: Layout,
    redirect: "/goldPanCollege/list",
    name: "goldPanCollege",
    meta: {
      title: "淘金学院",
      titleTh: "",
      titleEn: "",
      icon: "ums"
    },
    children: [{
        path: "addGoldPanCollege",
        name: "addGoldPanCollege",
        component: () => import("@/views/goldPanCollege/addGoldPanCollege"),
        meta: {
          title: "添加内容",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "listGoldPanCollege",
        name: "listGoldPanCollege",
        component: () => import("@/views/goldPanCollege/listGoldPanCollege"),
        meta: {
          title: "淘金学院列表",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/finSetMng",
    component: Layout,
    redirect: "/finSetMng/actualPaidSalesReport",
    name: "finSetMng",
    meta: {
      title: "财务结算(运营)",
      titleTh: "",
      titleEn: "",
      icon: "ums"
    },
    children: [{
      path: "actualPaidSalesReport",
      name: "actualPaidSalesReport",
      component: () => import("@/views/finSetMng/actualPaidSalesReport"),
      meta: {
        title: "实付金额销售报表",
        titleTh: "",
        titleEn: "",
        icon: "ums-admin"
      },
      hidden: true
    }, ]
  },
  {
    path: "/redEnvelopeMngGoldCoins",
    component: Layout,
    redirect: "/redEnvelopeMngGoldCoins/listRedMngGoldCoins",
    name: "redEnvelopeMngGoldCoins",
    meta: {
      title: "金币兑红包管理",
      titleTh: "",
      titleEn: "",
      icon: "ums"
    },
    children: [{
        path: "addRedMngGoldCoins",
        name: "addRedMngGoldCoins",
        component: () => import("@/views/redEnvelopeMngGoldCoins/addRedMngGoldCoins"),
        meta: {
          title: "添加/编辑金币红包",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "listRedMngGoldCoins",
        name: "listRedMngGoldCoins",
        component: () => import("@/views/redEnvelopeMngGoldCoins/listRedMngGoldCoins"),
        meta: {
          title: "金币兑红包管理列表",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
      },
    ]
  },
  {
    path: "/messagePush",
    component: Layout,
    redirect: "/messagePush/list",
    name: "messagePush",
    meta: {
      title: "消息管理",
      titleTh: "",
      titleEn: "",
      icon: "ums"
    },
    children: [{
        path: "addMessagePush",
        name: "addMessagePush",
        component: () => import("@/views/messagePush/addMessagePush"),
        meta: {
          title: "推送消息",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "listMessagePush",
        name: "listMessagePush",
        component: () => import("@/views/messagePush/listMessagePush"),
        meta: {
          title: "消息管理列表",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/specifyDistributionGoods",
    component: Layout,
    redirect: "/specifyDistributionGoods/listSpecifyDistirbute",
    name: "specifyDistributionGoods",
    meta: {
      title: "指定商品分润",
      titleTh: "",
      titleEn: "",
      icon: "ums"
    },
    children: [{
        path: "detailSpecifyDistirbute",
        name: "detailSpecifyDistirbute",
        component: () => import("@/views/specifyDistributionGoods/detailSpecifyDistirbute"),
        meta: {
          title: "指定商品分润详情",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "listSpecifyDistirbute",
        name: "listSpecifyDistirbute",
        component: () => import("@/views/specifyDistributionGoods/listSpecifyDistirbute"),
        meta: {
          title: "指定商品分润列表",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/couponmng",
    component: Layout,
    redirect: "/couponmng/couponInfo",
    name: "couponmng",
    meta: {
      title: "优惠券管理",
      titleTh: "จัดการคูปอง",
      titleEn: "Coupon management",
      icon: "ums"
    },
    children: [{
        path: "addCoupon",
        name: "addCoupon",
        component: () => import("@/views/couponmng/addCoupon"),
        meta: {
          title: "添加优惠券",
          titleTh: "เพิ่มคูปอง",
          titleEn: "Add coupon",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "couponInfo",
        name: "couponInfo",
        component: () => import("@/views/couponmng/couponInfo"),
        meta: {
          title: "优惠券管理",
          titleTh: "จัดการคูปอง",
          titleEn: "Coupon management",
          icon: "ums-admin"
        }
      },
      {
        path: "couponInfoMng",
        name: "couponInfoMng",
        component: () => import("@/views/couponmng/couponInfoMng"),
        meta: {
          title: "优惠券详情",
          titleTh: "รายละเอียดคูปอง",
          titleEn: "Coupon details",
          icon: "ums-admin"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/couponProMng",
    component: Layout,
    redirect: "/couponProMng/couponInfo",
    name: "couponProMng",
    meta: {
      title: "优惠券管理",
      titleTh: "จัดการคูปอง",
      titleEn: "Coupon management",
      icon: "ums"
    },
    children: [{
        path: "addCouponPro",
        name: "addCouponPro",
        component: () => import("@/views/couponProMng/addCoupon"),
        meta: {
          title: "添加优惠券",
          titleTh: "เพิ่มคูปอง",
          titleEn: "Add coupon",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "couponInfoMng",
        name: "couponInfoMng",
        component: () => import("@/views/couponProMng/couponInfoMng"),
        meta: {
          title: "优惠券详情",
          titleTh: "รายละเอียดคูปอง",
          titleEn: "Coupon details",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "couponProInfo",
        name: "couponProInfo",
        component: () => import("@/views/couponProMng/couponInfo"),
        meta: {
          title: "优惠券管理",
          titleTh: "จัดการคูปอง",
          titleEn: "Coupon management",
          icon: "ums-admin"
        }
      },
    ]
  },
  {
    path: "/voucherCode",
    component: Layout,
    redirect: "/voucherCode/list",
    name: "voucherCode",
    meta: {
      title: "兑换券券码",
      titleTh: "รหัสตั๋วแลก",
      titleEn: "Redemption Coupon code",
      icon: "ums"
    },
    children: [{
        path: "add",
        name: "add",
        component: () => import("@/views/voucherCode/add"),
        meta: {
          title: "添加兑换券券码",
          titleTh: "เพิ่มรหัสตั๋วแลก",
          titleEn: "Add redemption coupon code",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "edit",
        name: "edit",
        component: () => import("@/views/voucherCode/edit"),
        meta: {
          title: "编辑兑换券券码",
          titleTh: "เพิ่มรหัสตั๋วแลก",
          titleEn: "Edit redemption coupon code",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "addVoucher",
        name: "addVoucher",
        component: () => import("@/views/voucherCode/addVoucher"),
        meta: {
          title: "添加/编辑兑换券",
          titleTh: "เพิ่ม/แก้ไขตั๋วแลก",
          titleEn: "Add/edit redemption coupon codes",
        },
        hidden: true
      },
      // {
      //   path: "addPocket",
      //   name: "addPocket",
      //   component: () => import("@/views/sms/pocket/add"),
      //   meta: {
      //     title: "创建口袋任务"
      //   },
      //   hidden: true
      // },

      {
        path: "list",
        name: "list",
        component: () => import("@/views/voucherCode/list"),
        meta: {
          title: "兑换券券码管理",
          titleTh: "จัดการรหัสตั๋วแลก",
          titleEn: "Redemption coupon code management",
          icon: "ums-admin"
        }
      },
      {
        path: "giftList",
        name: "giftList",
        component: () => import("@/views/voucherCode/giftList"),
        meta: {
          title: "兑换礼品管理",
          titleTh: "จัดการของแลก",
          titleEn: "Gift management",
          icon: "ums-admin"
        }
      },
      {
        path: "shipList",
        name: "shipList",
        component: () => import("@/views/voucherCode/shipList"),
        meta: {
          title: "兑换发货管理",
          titleTh: "จัดการการจัดส่งของแลก",
          titleEn: "Shipment management",
          icon: "ums-admin"
        }
      },
      {
        path: "editAddress",
        name: "editAddress",
        component: () => import("@/views/voucherCode/editAddress"),
        meta: {
          title: "修改地址",
          titleTh: "แก้ไขที่อยู่",
          titleEn: "Modify address",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "shipListDetail",
        name: "shipListDetail",
        component: () => import("@/views/voucherCode/shipListDetail"),
        meta: {
          title: "兑换发货管理详情",
          titleTh: "รายละเอียดการจัดการการจัดส่ง",
          titleEn: "Shipment management details",
          icon: "ums-admin"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/invitation",
    component: Layout,
    redirect: "/invitation/listInvitation",
    name: "invitation",
    meta: {
      title: "邀请码管理",
      titleTh: "จัดการ",
      titleEn: "Invitation code management",
      icon: "ums",
    },
    children: [{
        path: "addInvitation",
        name: "addInvitation",
        component: () => import("@/views/invitation/add"),
        meta: {
          title: "添加邀请码",
          titleTh: "เพิ่มรหัสเชิญ",
          titleEn: "Add invitation code",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "editInvitation",
        name: "editInvitation",
        component: () => import("@/views/invitation/edit"),
        meta: {
          title: "编辑邀请码",
          titleTh: "แก้ไขรหัสเชิญ",
          titleEn: "Edit invitation code",
          icon: "ums-admin"
        },
        hidden: true
      },
      {
        path: "listInvitation",
        name: "listInvitation",
        component: () => import("@/views/invitation/list"),
        meta: {
          title: "邀请码管理",
          titleTh: "จัดการรหัสเชิญ",
          titleEn: "Invitation code management",
          icon: "ums-admin"
        }
      },
    ]
  },
  {
    path: "/brandApplicate",
    component: Layout,
    redirect: "/brandApplicate/brandApplicateList",
    name: "brandApplicate",
    meta: {
      title: "品牌申请",
      titleTh: "คำขอแบรนด์",
      titleEn: "Brand application",
      icon: "ums"
    },
    children: [{
        path: "brandApplicateList",
        name: "brandApplicateList",
        component: () => import("@/views/brandApplicate/brandApplicateList"),
        meta: {
          title: "服务申请跟进",
          titleTh: "ติดตามคำขอใช้บริการ",
          titleEn: "Service application follow-up",
          icon: "ums-admin"
        }
      },
      {
        path: "brandListAuth",
        name: "brandListAuth",
        component: () => import("@/views/brandApplicate/brandListAuth"),
        meta: {
          title: "品牌申请审核",
          titleTh: "ตรวจสอบการยื่นคำขอแบรนด์",
          titleEn: "Brand application audit",
          icon: "ums-admin"
        }
      },
      {
        path: "brandListAuthDetail",
        name: "brandListAuthDetail",
        component: () => import("@/views/brandApplicate/brandListAuthDetail"),
        meta: {
          title: "品牌申请详情",
          titleTh: "ข้อมูลการยื่นคำขอแบรนด์",
          titleEn: "Brand application details",
          icon: "ums-admin"
        },
        hidden: true
      },
    ]
  },
  {
    path: "/systemSet",
    component: Layout,
    redirect: "/systemSet/orderSet",
    name: "systemSet",
    meta: {
      title: "系统设置",
      titleTh: "ตั้งค่าระบบ",
      titleEn: "System settings",
      icon: "ums"
    },
    children: [{
        path: "orderSet",
        name: "orderSet",
        component: () => import("@/views/systemSet/orderSet"),
        meta: {
          title: "订单设置",
          titleTh: "ตั้งค่าคำสั่งซื้อ",
          titleEn: "Order settings",
          icon: "ums-admin"
        }
      },
      {
        path: "returnGood",
        name: "returnGood",
        component: () => import("@/views/systemSet/returnGood"),
        meta: {
          title: "退货/退款设置",
          titleTh: "ตั้งค่าการคืนสินค้า/คืนเงิน",
          titleEn: "Return/Refund settings",
          icon: "ums-admin"
        }
      },
      {
        path: "voucher",
        name: "voucher",
        component: () => import("@/views/systemSet/voucher"),
        meta: {
          title: "代金券使用规则设置",
          titleTh: "ตั้งค่ากฎการใช้บัตรกำนัล",
          titleEn: "Coupon rules setting",
          icon: "ums-admin"
        }
      },
      {
        path: "activeFee",
        name: "activeFee",
        component: () => import("@/views/systemSet/activeFee"),
        meta: {
          title: "活动奖励服务费设置",
          titleTh: "ตั้งค่าค่าบริการของรางวัลกิจกรรม",
          titleEn: "Activity reward service fee setting",
          icon: "ums-admin"
        }
      },
      {
        path: "withdraw",
        name: "withdraw",
        component: () => import("@/views/systemSet/withdraw"),
        meta: {
          title: "提现手续费设置",
          titleTh: "ตั้งค่าค่าธรรมเนียมการถอนเงิน",
          titleEn: "Withdrawal fee settings",
          icon: "ums-admin"
        }
      },
      {
        path: "headSysSetup",
        name: "headSysSetup",
        component: () => import("@/views/systemSet/headSysSetup"),
        meta: {
          title: "团长发展体系设置",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        }
      },
      {
        path: "redPackage",
        name: "redPackage",
        component: () => import("@/views/systemSet/redPackage"),
        meta: {
          // title: "红包闯关任务设置",
          // titleTh: "ตั้งค่าภารกิจฝ่าด่านพิชิตอั่งเปา",
          // titleEn: "Red packet activity settings",
          title: "红包闯关任务管理",
          titleTh: "จัดการภารกิจอั่งเปา",
          titleEn: "Red Packet Missions Management",
          icon: "ums-admin"
        }
      },
      {
        path: "redNetPackage",
        name: "redNetPackage",
        component: () => import("@/views/systemSet/redNetPackage"),
        meta: {
          title: "网红达人红包闯关任务设置",
          titleTh: "ตั้งค่าภารกิจฝ่าด่านพิชิตอั่งเปาสำหรับ MXWINNER KOL",
          titleEn: "Settings of red packet activity for MXWINNER KOL",
          icon: "ums-admin"
        }
      },
      {
        path: "getTimeSet",
        name: "getTimeSet",
        component: () => import("@/views/systemSet/getTimeSet"),
        meta: {
          title: "领奖时间设置",
          titleTh: "ตั้งค่าเวลาการรับรางวัล",
          titleEn: "Prize claim time settings",
          icon: "ums-admin"
        }
      },
      {
        path: "eiteQuestSetup",
        name: "eiteQuestSetup",
        component: () => import("@/views/systemSet/eiteQuestSetup"),
        meta: {
          title: "精英任务设置",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        }
      },
      {
        path: "contentRecommendate",
        name: "contentRecommendate",
        component: () => import("@/views/systemSet/contentRecommendate"),
        meta: {
          title: "内容推荐上传视频设置",
          titleTh: "",
          titleEn: "",
          icon: "ums-admin"
        }
      },
    ]
  },
  {
    path: "/ums",
    component: Layout,
    redirect: "/ums/admin",
    name: "ums",
    meta: {
      title: "系统管理",
      titleTh: "ตั้งค่าระบบ",
      titleEn: "System management",
      icon: "ums"
    },
    children: [{
        path: "admin",
        name: "admin",
        component: () => import("@/views/ums/admin/index"),
        meta: {
          title: "用户列表",
          titleTh: "รายการผู้ใช้",
          titleEn: "User list",
          icon: "ums-admin"
        }
      },
      {
        path: "role",
        name: "role",
        component: () => import("@/views/ums/role/index"),
        meta: {
          title: "角色列表",
          titleTh: "รายการบทบาท",
          titleEn: "Role list",
          icon: "ums-role"
        }
      },
      {
        path: "allocMenu",
        name: "allocMenu",
        component: () => import("@/views/ums/role/allocMenu"),
        meta: {
          title: "分配菜单"
        },
        hidden: true
      },
      {
        path: "allocResource",
        name: "allocResource",
        component: () => import("@/views/ums/role/allocResource"),
        meta: {
          title: "分配资源"
        },
        hidden: true
      },
      {
        path: "menu",
        name: "menu",
        component: () => import("@/views/ums/menu/index"),
        meta: {
          title: "菜单列表",
          titleTh: "รายการเมนู",
          titleEn: "Menu list",
          icon: "ums-menu"
        }
      },
      {
        path: "addMenu",
        name: "addMenu",
        component: () => import("@/views/ums/menu/add"),
        meta: {
          title: "添加菜单"
        },
        hidden: true
      },
      {
        path: "updateMenu",
        name: "updateMenu",
        component: () => import("@/views/ums/menu/update"),
        meta: {
          title: "修改菜单"
        },
        hidden: true
      },
      {
        path: "resource",
        name: "resource",
        component: () => import("@/views/ums/resource/index"),
        meta: {
          title: "资源列表",
          titleTh: "รายการทรัพยากร",
          titleEn: "Resource list",
          icon: "ums-resource"
        }
      },
      {
        path: "resourceCategory",
        name: "resourceCategory",
        component: () => import("@/views/ums/resource/categoryList"),
        meta: {
          title: "资源分类"
        },
        hidden: true
      }
    ]
  },
  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
});



// WEBPACK FOOTER //
// ./src/router/index.js